<template>
    <v-select dense outlined v-bind="$attrs" :items="items" item-text="name" item-value="id" v-on="$listeners" />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'TagGroupSelect',

    computed: {
        ...mapState('tag_group', {
            loaded: 'loaded',
            collection: 'collection',
        }),

        items() {
            if (this.collection) {
                return this.collection.models;
            } else {
                return [];
            }
        },
    },

    mounted() {
        this.loadData();
    },

    methods: {
        ...mapActions('tag_group', {
            loadData: 'load',
        }),
        reload() {
            this.loadData({ force: true });
        },
    },
};
</script>
